var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestoreFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Filter_Restore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.9752964,10.0247036 C15.1838549,10.2888903 13,12.6394118 13,15.5 C13,16.6774084 13.3699707,17.7684054 14,18.6630791 L14,20 L12,22 L12,14 L4,6 L4,4 L22,4 L22,6 L17.9752964,10.0247036 Z M16.1257661,13.4598646 C16.8203877,12.7647708 17.7736961,12.3333333 18.8323952,12.3333333 C20.9497936,12.3333333 22.66,14.0494958 22.66,16.1683333 C22.66,18.2871708 20.9497936,20.0033333 18.8323952,20.0033333 C17.045541,20.0033333 15.5556973,18.7809271 15.1293433,17.1270833 L16.1257661,17.1270833 C16.5185866,18.2440271 17.5820763,19.0445833 18.8323952,19.0445833 C20.4180488,19.0445833 21.7066917,17.7550646 21.7066917,16.1683333 C21.7066917,14.5816021 20.4180488,13.2920833 18.8323952,13.2920833 C18.0371732,13.2920833 17.3281801,13.6228521 16.8108068,14.1453708 L18.3533458,15.6889583 L15,15.6889583 L15,12.3333333 L16.1257661,13.4598646 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter_Restore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/vessel-filter",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "z_-Padding/Icons/Icon_Padding-_Null"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestoreFilter);
export default __webpack_public_path__ + "static/media/RestoreFilter.2285e56a0d1141d1f99d7128a7b15b19.svg";
export { ForwardRef as ReactComponent };